export let subTitle = (_d={})=> `<p class="info-subTitle">${_d.desc}</p>`;

export let title = (_d={})=> `<h3 class="info-title">${_d.title}</h3>`;

export let buttons = (_d={})=> `<div class="info-buttons"></div>`;

export let viewBtn = (_d={}, _ip)=> {
    return `
<a href="/view?tv=${_ip}&id=${_d.id}&from=popular" class="btn is-big is-filled info-more">
    <span class="btn-text">영상보기</span>
</a>`;
};

